import { useRef, useState, useEffect, useCallback, RefObject } from 'react'
import { useLocation } from 'react-router-dom'

import { LANGUAGES_LIST } from 'consts/translations'
import LanguageIcon from 'assets/svgr-icons/Language.svg'
import * as Styled from './styled'
import { findAndGetSelectedLanguage } from './helpers'
import ListItem from '../ListItem'

interface IProps {
  scrollableContentWrapperRef: RefObject<HTMLDivElement | null>
}

export const UserDropdownLanguages: React.FC<IProps> = props => {
  const { scrollableContentWrapperRef } = props
  const [selectedLanguage, setSelectedLanguage] = useState(
    findAndGetSelectedLanguage()
  )
  const [isOpenLanguages, setIsOpenLanguages] = useState(false)
  const userDropdownLanguagesWrapperRef = useRef<null | HTMLDivElement>(null)

  const { pathname } = useLocation()

  const changeLanguage = (lang: string) => {
    window.location.href = `${window.location.origin}/${lang}/v-editor${pathname}`
  }

  const toggleLanguages = useCallback(() => {
    if (isOpenLanguages) {
      scrollableContentWrapperRef.current?.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })

      const checkScroll = setInterval(() => {
        if (scrollableContentWrapperRef.current?.scrollTop === 0) {
          clearInterval(checkScroll)
          setIsOpenLanguages(false)
        }
      }, 50)
      return
    }
    setIsOpenLanguages(prev => !prev)
    // TODO: Recheck this
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenLanguages])

  useEffect(() => {
    if (isOpenLanguages) {
      userDropdownLanguagesWrapperRef.current?.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }, [isOpenLanguages])

  return (
    <div ref={userDropdownLanguagesWrapperRef}>
      <ListItem
        data={{
          id: 'language',
          icon: LanguageIcon,
          label: selectedLanguage.label,
          onClick: toggleLanguages,
          isExpandable: true,
          isExpanded: isOpenLanguages
        }}
      />
      {isOpenLanguages && (
        <div>
          {LANGUAGES_LIST.filter(
            item => item.code !== selectedLanguage.code
          ).map(language => {
            return (
              <Styled.UserDropdownLanguage
                onClick={() => {
                  setSelectedLanguage(language)
                  changeLanguage(language.code)
                  toggleLanguages()
                }}
                key={language.code}
              >
                <Styled.UserDropdownLanguageFlag src={language.flagImgSrc} />
                <Styled.UserDropdownLanguageText>
                  {language.label}
                </Styled.UserDropdownLanguageText>
              </Styled.UserDropdownLanguage>
            )
          })}
        </div>
      )}
    </div>
  )
}
